<div class="ws-popup-header">
  <div>{{ "Manual Resend" | translate }}</div>

  <div class="actions">
    <button (click)="cancelClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body">
    <form [formGroup]="form">
      <div class="form-container">
        <div *ngIf="!data.wineryId" class="field-wrapper">
          <label for="wineryId">
            {{ "Winery ID" | translate }}
          </label>
          <div class="input-wrapper">
            <input
              formControlName="wineryId"
              id="wineryId"
              type="text"
              matInput
            />
          </div>
        </div>

        <div *ngIf="!data.experienceId" class="field-wrapper">
          <label for="experienceId">
            {{ "Experience ID" | translate }}
          </label>
          <div class="input-wrapper">
            <input
              formControlName="experienceId"
              id="experienceId"
              type="text"
              matInput
            />
          </div>
        </div>

    <div class="field-wrapper">
      <label for="experienceId">{{"Experience id:" | translate}}</label>
      <input id="experienceId" formControlName="experienceId" type="text" />
    </div>

    <div class="field-wrapper">
      <label for="saleId">{{"Sale id" | translate}}</label>
      <input id="saleId" formControlName="saleId" type="text" />
    </div>

        <div *ngIf="!data.forcedLanguage" class="field-wrapper">
          <label for="forcedLanguage">
            {{ "Forced Language" | translate }}
          </label>
          <div class="input-wrapper">
            <input
              formControlName="forcedLanguage"
              id="forcedLanguage"
              type="text"
              matInput
            />
          </div>
        </div>

        <div *ngIf="!data.endpoint" class="field-wrapper">
          <label for="endpoint">
            {{ "Notification Type" | translate }}
          </label>
          <div class="input-wrapper">
            <ws-selector
              [options]="notificationTypes"
              [selected]="getSelectedNotificationType()"
              [formatter]="getNotificationTypeName.bind(this)"
              (selectedChange)="onSelectorChange('endpoint', $event)"
              [placeholder]="'Select notification type' | translate"
            >
            </ws-selector>
          </div>
        </div>

        <div *ngIf="data.emailAddress" class="field-wrapper email-choice-wrapper">
          <label>
            {{ "Email address" | translate }}
          </label>

          <div class="radio-options">
            <label
              class="radio-option"
              [class.selected]="emailChoice === 'booking'"
              (click)="selectEmailChoice('booking')"
            >
              <div class="radio-wrapper">
                <div class="radio-circle"></div>
                <div class="radio-content">
                  <div class="radio-label">{{ "Booking email" | translate }}</div>
                  <div class="radio-email">{{ data.emailAddress }}</div>
                </div>
              </div>
            </label>

            <label
              class="radio-option"
              [class.selected]="emailChoice === 'alternative'"
              (click)="selectEmailChoice('alternative')"
            >
              <div class="radio-wrapper">
                <div class="radio-circle"></div>
                <div class="radio-content">
                  <div class="radio-label">{{ "Alternative email address" | translate }}</div>
                  <div class="alternative-input">
                    <input
                      formControlName="emailAddress"
                      type="email"
                      matInput
                      [disabled]="emailChoice !== 'alternative'"
                      [placeholder]="'Enter alternative email address' | translate"
                    />
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="ws-popup-footer">
    <span></span>
    <div class="actions-wrapper">
      <ws-button
        [callToActionType]="'danger'"
        (click)="cancelClicked()"
        style="margin-right: 10px"
      >
        {{ "Cancel" | translate }}
      </ws-button>
      <ws-button
        [callToActionType]="'primary'"
        (click)="submitClicked()"
        [disabled]="form.invalid"
      >
        {{ "Resend" | translate }}
      </ws-button>
    </div>
  </div>
</div>